import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from '@angular/common';
import { environment } from "../../../environments/environment";
@Pipe({
    name: "templateFormate"
})
export class TablePipe implements PipeTransform {

    transform(val: any, args: any = ""): string {
        if (val !== undefined && val !== null) {
            // here we just remove the commas from value
            if (args == "") {
                return val.toString();
            } else if (args == "date") {
                var parsedDate = Date.parse(val);
                if (isNaN(parsedDate)) {
                    return "";
                }
                else {
                    var dateNow = new Date(val)
                    var a = new DatePipe("en-US").transform(val, 'dd-MMM-yyyy');
                    return a;
                }
            }
            else if (args == "decimal") {
                return Number(val.toString().replace(",", "")).toFixed(environment.noofdecimal);
            }
            return val.toString();
        } else {
            return "";
        }
    }

}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/pipe/table.pipe.ts